import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { KpiCardGridDirection } from './pulse-kpi-card.types';

/**
 * The responsive layer around KPI cards: a row that wraps into as many equal columns as fit, or a
 * single column stack. Rows share one height, so every card in a row is as tall as the tallest.
 */
@Component({
    selector: 'pulse-kpi-card-grid',
    template: '<ng-content />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'pulse-kpi-card-grid',
        '[class.pulse-kpi-card-grid--column]': "direction() === 'column'",
        '[style.--pulse-kpi-card-min-width]': 'minCardWidth() + "px"',
    },
    styleUrl: './pulse-kpi-card-grid.component.scss',
})
export class PulseKpiCardGridComponent {
    readonly direction = input<KpiCardGridDirection>('row');
    readonly minCardWidth = input(230);
}
